import { FilmTile } from "@components/film/FilmTile"
import { SubpageContentBlocks } from "@components/page/SubpageContentBlocks"
import { TabControl } from "@components/ui/TabControl"
import { ResultBrowser } from "@components/util/ResultBrowser"
import { trackEvent } from "@features/tracking/tracking"
import { useSearchParams } from "eddev/routing"
import { defineView } from "eddev/views"
import { useRef, useState } from "react"

export default defineView("single-strand", (props) => {
  const ref = useRef<HTMLDivElement>(null)
  const [_, params] = useSearchParams({
    mode: "a-z" as "a-z" | "date",
  })

  const items =
    params.get("mode") === "a-z"
      ? props.strand?.films?.map((film) => ({ film, session: null }))
      : props.strand?.films
          ?.flatMap((film) => film?.sessions?.map((session) => ({ film, session })))
          .sort((a, b) => a?.session?.info?.dateTime?.localeCompare(b?.session?.info?.dateTime!)!)

  return (
    <div data-mixpanel-template="Single Strand" data-mixpanel-strand={props.strand?.title}>
      <div data-mixpanel-area="Strand Content">
        <SubpageContentBlocks blocks={props.strand?.contentBlocks} />
      </div>
      <div className="h-3" />
      <div data-mixpanel-area="Strand Film Grid" ref={ref}>
        <ResultBrowser
          itemsPerPage={0}
          totalItems={0}
          tabs={{
            value: params.get("mode"),
            onValueChange: (mode) => {
              params.set("mode", mode as any)
              trackEvent(
                "Toggle Strand Mode",
                {
                  Mode: mode,
                },
                ref.current,
              )
            },
            items: [
              { label: "A-Z", value: "a-z" },
              { label: "Date", value: "date" },
            ],
          }}
          animationKey={params.get("mode")}
        >
          <div className="grid-auto">
            {items?.map((item, i) => {
              return (
                <div key={i} className="col-span-12 sn:col-span-6 md:col-span-4 lg:col-span-3 mb-4">
                  <FilmTile film={item?.film!} session={item?.session!} />
                </div>
              )
            })}
          </div>
        </ResultBrowser>
      </div>
      <div className="h-10" />
    </div>
  )
})
